import { render, staticRenderFns } from "./PeoplePetitionersGrid.vue?vue&type=template&id=a79264a0&"
import script from "./PeoplePetitionersGrid.vue?vue&type=script&lang=js&"
export * from "./PeoplePetitionersGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports